// Practice-area landing pages: keyword-targeted, one per high-intent query.
// Data lives in practiceAreas.json so the Node build scripts (sitemap, prerender,
// inject-seo) can share the exact same source as the React app.
import PRACTICE_AREAS_DATA from './practiceAreas.json';

export const PRACTICE_AREAS = PRACTICE_AREAS_DATA;

export const getPracticeArea = (slug) => PRACTICE_AREAS.find((p) => p.slug === slug);
